module.exports = __webpack_public_path__ + "static/efadp_logo_color_05-bfda92f582a7bddb45086a34e321296f.jpg";